import ItemReadingPaneViewState from '../schema/ItemReadingPaneViewState';
import { getReadingPaneStore } from '../Store';

/**
 * Selector to get the itemReadingPaneViewState State from the store
 * @param isPreview
 */
export const getItemReadingPaneViewState = (
    isPreview?: boolean
): ItemReadingPaneViewState | null => {
    const { itemPreviewViewState, itemReadingPaneViewState } = getReadingPaneStore();

    return isPreview ? itemPreviewViewState : itemReadingPaneViewState;
};
